import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=3d53cd9b"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=3d53cd9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports